import React from "react";
import { CSSProperties } from "react";
import FocusLock from "react-focus-lock";
import { RemoveScroll } from "react-remove-scroll";
import styles from "./Modal.module.css";

interface Props {
  open: boolean;
  title: string;
  type: string;
  handleDismiss: () => void;
  children: React.ReactNode;
  hideCloseButton?: boolean;
}

function Modal({
  open,
  title,
  type,
  handleDismiss,
  children,
  hideCloseButton,
}: Props) {
  React.useEffect(() => {
    function handleKeyDown(event: KeyboardEvent) {
      if (event.code === "Escape" && hideCloseButton !== true) {
        handleDismiss();
      }
    }

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleDismiss, hideCloseButton]);

  if (!open) {
    return null;
  }

  let bgColor: CSSProperties | undefined;
  switch (type) {
    case "error":
      bgColor = { backgroundColor: "red" };
      break;
    case "success":
      bgColor = { backgroundColor: "green" };
      break;
    case "warning":
      bgColor = { backgroundColor: "orange" };
      break;
  }

  return (
    <FocusLock returnFocus={true}>
      <RemoveScroll>
        <div className={styles.modal}>
          {hideCloseButton !== true && (
            <button
              onClick={() => {
                handleDismiss();
              }}
              className={styles["close-button"]}
            >
              X
            </button>
          )}
          <h3 className={styles.title} style={bgColor}>
            {title}
          </h3>
          <div className={styles.content}>{children}</div>
        </div>
      </RemoveScroll>
    </FocusLock>
  );
}

export default React.memo(Modal);
